import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationBar } from 'src/services/notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { environment } from 'src/environment';
import { emsSaaSSubscription, emsWorkspace } from 'src/models/emsModels';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { SettingsNameComponent } from '../settings-name/settings-name.component';
import { SettingsOwnerComponent } from '../settings-owner/settings-owner.component';
import { SettingsUserComponent } from '../settings-user/settings-user.component';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { userInfo } from 'src/models/userModels';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {
  notificationBar: NotificationBar;
  workspace = new emsWorkspace();
  lastSync: Date = new Date();
  isLoading = false;
  isLoadingPortal = false;
  displayedColumns: string[] = ['info', 'value', 'edit'];
  workspaceSource = new MatTableDataSource<any>;
  isChangingName = false;
  isChangingOwner = false;
  isUpdatingUser = false;
  isOwner = false;
  hasSubscription = true;

  constructor(private snackBar: MatSnackBar, private fireFunctions: AngularFireFunctions, private location: Location, private db: AngularFireDatabase, private title: Title, public dialog: MatDialog,
    private fireAuth: AngularFireAuth
  ) {
    this.notificationBar = new NotificationBar(snackBar);
  }
  
  ngOnInit() {
    this.title.setTitle("Settings - EsportsMS");
    this.workspace.uid  = this.location.path().split("/")[1];
    this.getWorkspace();
  }

  async getWorkspace() {
    this.isLoading = true;
    this.isOwner = false;
    var tempWorkspaceDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/workspaces/' + this.workspace.uid);
    await tempWorkspaceDBRef.once("value").then( async workspace => {
      this.isLoading = false;
      var emsWorkspace = workspace.toJSON() as emsWorkspace;
      if (emsWorkspace?.subscription) {
        this.hasSubscription = true;
      }
      else {
        this.hasSubscription = false;
      }
      this.workspace.name = emsWorkspace.name;
      this.workspace.owner = emsWorkspace.owner;
      this.workspaceSource = new MatTableDataSource([
        {
          info: "Name", value: this.workspace.name,
        },
        {
          info: "Owner", value: this.workspace.owner, loading: true,
        }, 
        {
          info: "User", value: 0, loading: true,
        },
        {
          info: "Storage", value: "0.00 MB", loading: true,
        },
      ]);
      if (this.workspace.owner == (await (this.fireAuth.currentUser)).uid) {
        this.isOwner = true;
      }
      this.getOwnerInfo()
      this.getUserCount();
      this.getStorageSize();
    })
  }

  async getOwnerInfo() {
    var uid = this.workspace.owner
    this.fireFunctions.httpsCallable("user-getInfo")({uid}).subscribe( res => {
      var userInfo = res as userInfo;
      this.workspaceSource.data[1].value = userInfo.displayName + " - " + userInfo.email;
      this.workspaceSource.data[1].loading = false;
      }, err => {
      this.isLoading = false;
      if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
    this.lastSync = new Date();
  }

  async getUserCount() {
    var workspaceID = this.workspace.uid;
    this.fireFunctions.httpsCallable("esportsms-getUserCount")({workspaceID}).subscribe( res => {
      this.workspaceSource.data[2].value = res;
      this.workspaceSource.data[2].loading = false;
      }, err => {
      this.isLoading = false;
      if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  async getStorageSize() {
    var workspaceID = this.workspace.uid;
    this.fireFunctions.httpsCallable("esportsms-getStorageSize")({workspaceID}).subscribe( res => {
      this.workspaceSource.data[3].value = res + " MB";
      this.workspaceSource.data[3].loading = false;
      }, err => {
      this.isLoading = false;
      if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  async changeName() {
    this.isChangingName = true;
    var dialogRef = this.dialog.open(SettingsNameComponent, {
      data: {
        workspaceID: this.workspace.uid,
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    this.isChangingName = false;
    if (res != null) {
      this.workspaceSource.data[0].value = res;
    }
  }

  async changeOwner() {
    this.isChangingOwner = true;
    var dialogRef = this.dialog.open(SettingsOwnerComponent, {
      data: {
        workspaceID: this.workspace.uid,
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    this.isChangingOwner = false;
    if (res != null) {
      this.getWorkspace();
    }
  }

  async updateUser() {
    this.isUpdatingUser = true;
    var dialogRef = this.dialog.open(SettingsUserComponent, {
      data: {
        workspaceID: this.workspace.uid,
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    this.isUpdatingUser = false;
    if (res == true) {
      this.getWorkspace();
    }
  }

  openCustomerPortal() {
    // this.isLoadingPortal = true;
    // var workspaceID = this.workspace.id;
    // this.fireFunctions.httpsCallable("stripe-getEmsCustomer")({workspaceID}).subscribe( res => {
    //   var customerID = res;
    //   this.fireFunctions.httpsCallable("stripe-getcustomerPortal")({customerID, workspaceID}).subscribe( res => {
    //     window.location.href = res;
    //   }, err => {
    //     this.isLoadingPortal = false;
    //     this.notificationBar.showUnknownError();
    //   });
    // }, err => {
    //   this.isLoading = false;
    //   if (err.code == "functions/permission-denied") {
    //     this.notificationBar.show("Missing permission!");
    //   }
    //   else {
    //     this.notificationBar.showUnknownError();
    //   }
    // });
  }

  deleteWorkspace() {
    alert("DELETE COMING SOON!")
  }
}
